<template lang="pug">
  transition-group.TheToaster.toaster-list(
    name="toaster-transition",
    tag="div"
  )
    TheToasterItem.toaster-list-item(
      v-for="item in list",
      :key="item.id",
      v-bind="item",
      @hide="removeItem(item.id)",
    )
</template>

<script>
import { mapGetters } from 'vuex';
import { generateId } from 'Utils/common';
import TheToasterItem from './TheToasterItem';

export default {
  name: 'TheToaster',
  components: {
    TheToasterItem,
  },
  data() {
    return {
      list: [],
    };
  },
  computed: {
    ...mapGetters('toaster', { storeMessage: 'message' }),
  },
  watch: {
    storeMessage: {
      immediate: true,
      handler({ text, options } = {}) {
        if (text) {
          this.addItem(text, options);
        }
      },
    },
    $route: 'onRouteChange',
  },
  methods: {
    addItem(text, { code = text, id = generateId(), ...options }) {
      this.list = this.list.filter(item => item.code !== code);
      this.list = this.list.concat({ text, code, id, ...options, created: Date.now() });
      return id;
    },
    removeItem(itemId) {
      this.list = this.list.filter(item => item.id !== itemId);
    },
    onRouteChange() {
      this.list = this.list.filter(({ created, timeout }) => {
        const lifetime = Date.now() - created;
        return lifetime < 500 || timeout === 0 || timeout >= 10000;
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  @import '~Styles/_variables'
  .toaster-list
    position: fixed
    z-index: 999999
    pointer-events: none
    right: 12px
    bottom: 12px
    max-width: 100%
    @media screen and (max-width: 576px)
      transform: translate(-50%, 0%)
      right: auto
      left: 50%
      bottom: 5px
      &:before
        content: ''
        position: absolute
        z-index: 1
        left: -30px
        top: -50px
        width: 200%
        height: 200%
        background: rgb(255,255,255)
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba($boulder, 0.5) 50%)
    @media screen and (max-width: 374px)
      max-width: 100%
  .toaster-list-item
    opacity: 1
    transition-property: opacity, transform
    transition-duration: .5s
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1)
  .toaster-transition
    &-enter
      opacity: 1
      transform: scale(.8)
    &-enter,
    &-leave-to
      opacity: 0
      transform: scale(.8)
      transition-duration: .25s
</style>
